import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import GiftBoxIcon from "@mui/icons-material/CardGiftcard"; // Placeholder for gift box
import BookIcon from "@mui/icons-material/MenuBook"; // Placeholder for open book
import { styled } from "@mui/material/styles";
import {

Box,
Typography,
Grid,
Paper,
List,
ListItem,
ListItemIcon,
ListItemText,
Button,
Divider,
} from "@mui/material";

const tools = [
"Tool 10: My Special Family",
"Tool 11: “Our Family Fun List” Poster",
"Tool 12: Family Rituals",
"Tool 13: Family Bucketlist",
"Tool 14: Family Rules",
"Tool 15: Weekly Family Meeting",
"Tool 16: Family Treasure Box",
];

const MainImage = styled("img")({
width: "100%",
maxWidth: 550,
borderRadius: 8,
boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
});

const IconImage = styled("img")({
width: 40,
marginRight: 16,
});

const OnlyToolYouNeed = () => (
<Box
    sx={{
        background: "#fff",
        py: { xs: 4, md: 8 },
        px: { xs: 2, md: 0 },
        maxWidth: 1120,
        mx: "auto",
    }}
>
    <Paper elevation={0} sx={{ p: { xs: 2, md: 4 } }}>
        <Typography
            variant="h3"
            
            fontWeight={700}
            gutterBottom
            sx={{ fontSize: { xs: 24, md: 32 } }}
        >
            The only{" "}
            <Box component="span" sx={{ color: "primary.main" }}>
                Positive Psychology
            </Box>{" "}
            tool you'll ever need!
        </Typography>

        <Typography variant="h5" sx={{ mt: 2, mb: 3, fontSize: 24 }}>
            What will you receive?
        </Typography>

        <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <MainImage
                    src="/assets/family-fun-time-ritual.jpeg"
                    alt="Family Fun Time Ritual"
                    loading="lazy"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Box display="flex" alignItems="flex-start" mb={2}>
                    <IconImage
                        src="/assets/openbook.png"
                        alt="Open Book"
                        loading="lazy"
                    />
                    <Typography variant="body1" sx={{ fontSize: 18 }}>
                        A colorful 34+ page PDF packed with tools designed to spark real
                        conversations, meaningful togetherness, and lifelong memories –
                        all grounded in the science of Positive Psychology and the love of
                        family. Take your time, enjoy the activities, and notice the
                        little changes that start to unfold. That’s where the magic
                        begins.
                    </Typography>
                </Box>

                <Typography variant="h6" sx={{ fontSize: 24, mt: 3, mb: 1 }}>
                    Bonus materials:
                </Typography>

                <Box display="flex" alignItems="flex-start" mb={2}>
                    <IconImage
                        src="/assets/giftbox.png"
                        alt="Gift Box"
                        loading="lazy"
                        style={{ width: 45 }}
                    />
                    <Typography variant="body1" sx={{ fontSize: 18 }}>
                        Extra tools that invite you to slow down, connect deeper, and
                        create memories that truly last.
                    </Typography>
                </Box>

                <List dense>
                    {tools.map((tool) => (
                        <ListItem key={tool} sx={{ pl: 0 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                                <CheckCircleIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography sx={{ fontSize: 18 }}>{tool}</Typography>
                                }
                            />
                        </ListItem>
                    ))}
                </List>

                <Box display="flex" alignItems="flex-start" mt={2}>
                    <IconImage
                        src="/assets/giftbox.png"
                        alt="Gift Box"
                        loading="lazy"
                        style={{ width: 45 }}
                    />
                    <Typography variant="body1" sx={{ fontSize: 18 }}>
                        Get my daily rituals checklist
                    </Typography>
                </Box>
            </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
                <Typography variant="h6" sx={{ fontSize: 24 }}>
                    Regular price:{" "}
                    <Box component="span" sx={{ textDecoration: "line-through" }}>
                        $37
                    </Box>
                </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                <Typography
                    variant="h6"
                    sx={{ fontSize: 24, fontWeight: 700, color: "primary.main" }}
                >
                    Special price offer:{" "}
                    <Box component="span" sx={{ fontSize: 32, fontWeight: 700 }}>
                        $0
                    </Box>
                </Typography>
            </Grid>
        </Grid>

        <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
            <Grid item xs={12} md={7}>
                <Typography variant="body1" sx={{ fontSize: 24 }}>
                    This special offer <strong>is only available now!</strong>
                </Typography>
            </Grid>
            <Grid item xs={12} md={5}>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    sx={{
                        fontWeight: 700,
                        fontSize: 20,
                        px: 4,
                        py: 1.5,
                        width: "100%",
                        mt: { xs: 2, md: 0 },
                    }}
                >
                    Download now!
                </Button>
            </Grid>
        </Grid>
    </Paper>
</Box>
);

export default OnlyToolYouNeed;